/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
const configFile = (env, instance = 'paytm') => {
  let sourceConfig = {};
  const envString = env || process.env.REACT_APP_ENV || 'development';
  if (envString === 'staging') {
    sourceConfig = process.env.REACT_APP_V2
      ? require(`../${envString}V2.js`)
      : require(`../${envString}.js`);
  } else if (envString === 'production') {
    sourceConfig = process.env.REACT_APP_V2
      ? require(`../${envString}V2.json`)
      : require(`../${envString}.json`);
  } else {
    sourceConfig = require(`../${envString}.json`);
  }
  return sourceConfig[process.env.INSTANCE || instance];
};
export default configFile;
